import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { TonsPerYardService } from 'src/app/_services/tons-per-yard/tons-per-yard.service';
import { BlDetails } from 'src/app/interfaces/bl.interfaces';
import { CabotageEntry } from 'src/app/interfaces/cabotageBatches.interfaces';
import { ExportEntry } from 'src/app/interfaces/exportationBatches.interfaces';
import { LocationInterface, TranportLine } from 'src/app/interfaces/lotes.interfaces';
import { AmountsByInputLocationsComponent } from 'src/app/shared/components/amounts-by-input-locations/amounts-by-input-locations.component';

/**
 * Componente que gestiona el formulario de entrada por ajuste de un lote de cabotaje,
 * permitiendo registrar o actualizar entradas de tipo ajuste con sus cantidades por ubicación.
 */
@Component({
  selector: 'app-cabotage-entry-adjustment',
  templateUrl: './cabotage-entry-adjustment.component.html',
  styles: [`
    @media (max-width: 950px) {
      .container-grid {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
  `]
})
export class CabotageEntryAdjustmentComponent implements OnInit {
  @Input() containerStyles = {
    'grid-template-columns': 'repeat(4, 1fr)'
  };
  @Input() movimiento: string = 'crear';
  @Input() entryDetalle: ExportEntry[] = [];
  @Input() locations: LocationInterface[] = [];
  @Output() onRegresar = new EventEmitter<boolean>();
  @Output() onTipoEntrada = new EventEmitter<string>();
  @Input() entriesType: TranportLine[] = [];
  @Input() blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
  };
  entryForm: FormGroup;
  overlay: boolean = false;
  mensajeOverlay: string = '';
  iconoOverlay: string = '';
  buttons: boolean = false;
  loading: boolean = false;
  entry: CabotageEntry = {
    cabotage_batch_id:      0,
    precinct_key:         0,
    tractor_plates:       '',
    transport_type_id:    0,
    trailer_id:           0,
    origin_weight:        0,
    gross_weight:         0,
    tare_weight:          0,
    net_weight:           0,
    van_plate:            '',
    folio_ticket_number:  '',
    origin_weight2:       0,
    gross_weight2:        0,
    tare_weight2:         0,
    net_weight2:          0,
    van_plate2:           '',
    folio_ticket_number2: '',
    total_weight:         0,
    cabotage_entrance_ticket:      '',
    checker_name:         '',
    operator_name:        '',
    transport_line:       '',
    admission_date:       '',
    number_pieces :       0,
    number_pieces2:       0,
    total_pieces  :       0,
    location_id:          0,
  };
  batchValue: number = 0;
  id: number = 0;
  tipoEntrada: FormControl = new FormControl('2');
  @ViewChild(AmountsByInputLocationsComponent) amountsComponent!: AmountsByInputLocationsComponent;

  constructor(
    private authService: AuthService,
    private loteCabotajeService: LoteCabotajeService,
    private amountsPerYardSvc: TonsPerYardService,
    private loteService: LoteService,
    private fb: FormBuilder,
    private router: Router,
  ) {
    this.entryForm = this.fb.group({
      entry_type_id: [],
      total_weight: [, [Validators.required, Validators.pattern(/^(?!0\d)\d{0,11}(?:\.\d{1,3})?$/)]],
      total_pieces  : [0, [Validators.required, Validators.pattern(/^\d{1,11}$/)]],
      admission_date: [this.getDate(), [Validators.required]],
      precinct_key: [201, [Validators.required]],
    });
  }

  ngOnInit(): void {
    const parts = this.router.url.split("/");
    this.batchValue = Number(parts[parts.length - 1]);
    this.tipoEntrada.valueChanges.subscribe( tipoEntrada => {
      this.onTipoEntrada.emit(tipoEntrada);
    });
    if (this.loteService.granel) {
      this.entryForm.get('total_pieces')?.disable();
    }
    this.entry = {
      ...this.entry,
      ...this.entryForm.value
    };
    if (this.router.url.includes('entry-list')) {
      this.entryForm.reset({
        ...this.entryDetalle[0],
        admission_date: this.entryDetalle[0]?.admission_date.substring(0, 10),
      });
      if (this.movimiento === 'actualizar') {
        this.entryForm.get('entry_type_id')?.disable();
      }
      if (this.entryDetalle[0].id) {
        this.id = this.entryDetalle[0].id;
      }
      if (this.movimiento === 'detalle') {
        this.entryForm.disable();
      }
    }
    this.entryForm.get('precinct_key')?.disable();
  }

  /**
   * Valida y envía el formulario para crear o actualizar la entrada por ajuste del lote de cabotaje,
   * mostrando los mensajes de éxito o error correspondientes.
   */
  saveEntry() {
    if (!this.authService.isValidPath('cabotage', 'entries', 'create')) {
      return;
    }
    const invalidLocationsForm = this.amountsComponent.isInvalidForm();
    if (this.entryForm.invalid || invalidLocationsForm) {
      this.entryForm.markAllAsTouched();
      this.mensajeOverlay = 'Favor de verificar la información';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.buttons = false;
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000)
      return;
    }
    if( Number(this.entryForm.get('total_weight')?.value) === 0 ) {
      this.mensajeOverlay = 'No es posible realizar un registro con tonelaje en 0';
      this.iconoOverlay = 'bi bi-exclamation-circle-fill';
      this.buttons = false;
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },3000)
      return;
    }
    this.loading = true;
    this.entry = {
      ...this.entry,
      ...this.entryForm.value,
      cabotage_batch_id: this.batchValue,
      entry_type_id: Number(this.tipoEntrada.value),
      admission_date: this.entryForm.get('admission_date')?.value + ' 00:00:00',
      total_weight: Number(this.entryForm.get('total_weight')?.value),
      total_pieces: Number(this.entryForm.get('total_pieces')?.value),
      transport_type_id: null,
      trailer_id: null,
      location_id: null,
      transport_line: null
    };
    if (this.movimiento === 'actualizar') {
      this.entry = {
        ...this.entry,
        id: this.entryDetalle[0].id,
      };
      this.loteCabotajeService.updateCabotageEntry(this.entry)
      .subscribe({
        next: response => {
          if (response.error) {
            this.loading = false;
            this.mensajeOverlay = response.message.includes('tonnage')
            ? 'La suma de toneladas de entrada es mayor a las toneladas del lote'
            : response.message.includes('pieces')
            ? 'La suma de piezas es mayor a las piezas totales del lote'
            : 'Lo sentimos no fue posible actualizar la entrada, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 4000);
            return;
          }
          this.loteCabotajeService.getCabotageBatch(this.batchValue)
          .subscribe({
            next: batch => {
              this.loteCabotajeService.loteInfoCabotage = batch[0];
              this.loading = false;
              this.mensajeOverlay = 'La entrada fue actualizada de manera correcta';
              this.iconoOverlay = 'bi bi-check2';
              this.buttons = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
                this.regresar();
              }, 2000);
            },
            error: (e) => {
              this.loading = false;
              this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
              this.iconoOverlay = 'bi bi-exclamation-circle-fill';
              this.buttons = false;
              this.overlay = true;
              setTimeout(() => {
                this.overlay = false;
              }, 3000);
            },
          });
        },
        error: (e) => {
          this.loading = false;
          this.mensajeOverlay = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
      return;
    }
    this.loteCabotajeService.createCabotageEntry(this.entry)
    .subscribe({
      next: response => {
        if (response.error) {
          this.mensajeOverlay = response.message.includes('tonnage')
          ? 'La suma de toneladas liberadas es mayor a las toneladas del lote'
          : response.message.includes('pieces')
          ? 'La suma de piezas es mayor a las piezas totales del lote'
          : 'Lo sentimos no fue posible agregar la entrada, inténtelo más tarde';
          this.loading = false;
          this.iconoOverlay = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 4000);
          return;
        }
        this.loteCabotajeService.getCabotageBatch(this.batchValue)
        .subscribe({
          next: batch => {
            this.loteCabotajeService.loteInfoCabotage = batch[0];
            this.loading = false;
            this.mensajeOverlay = 'La entrada fue agregada de manera correcta';
            this.iconoOverlay = 'bi bi-check2';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
              if (this.router.url.includes('ship-list')) {
                this.router.navigate([`ship-list/${this.blDetails.operation_number}/cabotage/batch-movement/entry-list`, this.batchValue]);
              } else {
                this.router.navigate([`/cabotage/batch-movement/entry-list`, this.batchValue])
              }
            }, 2000);
          },
          error: (e) => {
            this.loading = false;
            this.mensajeOverlay = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
            this.iconoOverlay = 'bi bi-exclamation-circle-fill';
            this.buttons = false;
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.loading = false;
        this.mensajeOverlay = 'Error en el servidor al crear el registro, inténtelo más tarde';
        this.iconoOverlay = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Indica si un campo del formulario de entrada es inválido y ha sido tocado por el usuario.
   * @param campo - Nombre del control del formulario a validar.
   * @returns `true` si el campo tiene errores y fue tocado; de lo contrario `null` o `false`.
   */
  campoEsValido( campo: string): boolean | null {
    return this.entryForm.get(campo)!.errors &&
    this.entryForm.get(campo)!.touched;
  }

  /**
   * Obtiene la fecha actual con formato `YYYY-MM-DD`.
   * @returns La fecha actual como cadena de texto.
   */
  getDate(): string {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const date = `${year}-${month}-${day}`;
    return date;
  }

  /**
   * Emite el evento para regresar a la vista anterior del flujo de entradas.
   */
  regresar() {
    this.onRegresar.emit(true);
  }
}
